import type { IntlShape } from 'react-intl'
import type { CurrentRefinementsConnectorParamsRefinement } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements'

import { formatTimestampToDate } from 'Portal/src/utilities/dates/dates.utils'
import { getReturnCasePortalStatusTranslationId } from 'Portal/src/utilities/getReturnCasePortalStatus/getReturnCasePortalStatus.utils'

import { DATE_ATTRIBUTES, FILTER_SEPARATORS } from './ActiveFilters.constants'

const isDate = (attribute: string) =>
  DATE_ATTRIBUTES.some(string => attribute.includes(string))

const isBoolean = (attribute: string) =>
  attribute.includes('is_') || attribute.includes('has_')

export const getSeparator = (
  refinements: CurrentRefinementsConnectorParamsRefinement[],
) => {
  const { attribute, type, value } = refinements[0]

  if (isDate(attribute)) {
    if (value === -1) {
      return FILTER_SEPARATORS.NONE
    }

    return FILTER_SEPARATORS.DATE
  }

  return type === 'numeric'
    ? FILTER_SEPARATORS.NUMERIC
    : FILTER_SEPARATORS.DEFAULT
}

export const parseRefinement = (
  refinement: CurrentRefinementsConnectorParamsRefinement,
  intl: IntlShape,
) => {
  const { attribute, label, value } = refinement

  if (isDate(attribute)) {
    if (value === -1) {
      return null
    }

    return formatTimestampToDate(value)
  }

  if (isBoolean(attribute) && typeof value === 'number') {
    return value === 1
      ? intl.formatMessage({ id: 'Yes' })
      : intl.formatMessage({ id: 'No' })
  }

  return label
}

export const parseReturnCasePortalStatusRefinements = (
  refinements: CurrentRefinementsConnectorParamsRefinement[],
  intl: IntlShape,
) =>
  refinements
    .reduce<string[]>((result, item) => {
      const { value } = item

      const formattedLabel = intl.formatMessage({
        id: getReturnCasePortalStatusTranslationId(value.toString()),
      })

      if (!result.includes(formattedLabel)) {
        result.push(formattedLabel)
      }

      return result
    }, [])
    .join(', ')
